module.exports = "/fonts/nucleo-icons.eot?8224e0160e362e117cbe00495919e2af";